module.exports = __webpack_public_path__ + "img/IMG_2248_L.51381f9b.webp";